/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import {
  getFlightHoldQueuesApi,
  getFlightPendingHoldQueuesApi,
  performticketing,
  releaseTicketApi,
} from '../../api/flightApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { TicketsIcon } from '../../shared/components/app-icons/AppIcons';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  DATE_MONTH_YEAR_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';

const iconStyle = { fontSize: 22, marginRight: 8, color: '#374471' };

function FlightHoldQueues({ isPending = false }) {
  const navigate = useNavigate();
  const agentId = getUserAgentId();
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [holdQueuesList, setHoldQueuesList] = useState([]);
  const allHoldQueuesListRef = useRef([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const selectedTransactionRef = useRef(undefined);
  const [alert, setAlert] = useState(undefined);
  const [showReleasePopup, setShowReleasePopup] = useState(false);

  const getFlightHoldQueues = async () => {
    setIsLoading(true);
    const response = isPending
      ? await getFlightPendingHoldQueuesApi(agentId)
      : await getFlightHoldQueuesApi(agentId);
    if (response?.Root?.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.FlightRecord)
          ? list.FlightRecord
          : [list.FlightRecord];
        setHoldQueuesList(list);
        allHoldQueuesListRef.current = list;
      } else {
        setHoldQueuesList([]);
      }
    } else {
      setHoldQueuesList([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getFlightHoldQueues();
  }, [isPending]);
  const getFlightTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  const setSearchResults = debounce((val) => {
    let data = [...allHoldQueuesListRef.current];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setHoldQueuesList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  function FlightDetail({ info, value }) {
    return (
      <div className="d-flex flex-column">
        <span className="my-bookings-page__booking_header_info">{info}</span>
        <span className="my-bookings-page__booking_header_value">{value}</span>
      </div>
    );
  }

  const handleClosePerformBookingModal = () => {
    setShowConfirmPopup(false);
    selectedTransactionRef.current = undefined;
  };
  const handleCloseReleasePopup = () => {
    setShowReleasePopup(false);
    selectedTransactionRef.current = undefined;
  };

  const handlePerformTicket = async () => {
    setIsLoading(true);
    const res = await performticketing(selectedTransactionRef.current);
    if (res && res.ApiStatus?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Hold Flight',
        description: `${res.ApiStatus.Message}, Redirecting to Ticket page...`,
      });
      setTimeout(() => {
        navigate(`/flight/ticket/${selectedTransactionRef.current}`);
      }, 2000);
      // handleClosePerformBookingModal();
    } else {
      setAlert({
        variant: 'error',
        title: 'Hold Flight',
        description: res.ApiStatus?.Message,
      });
    }
    setIsLoading(false);
  };

  const handleReleaseTicket = async () => {
    setIsLoading(true);
    const res = await releaseTicketApi(selectedTransactionRef.current);
    if (res && res.ApiStatus?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Release Flight',
        description: `${res.ApiStatus.Message}, Redirecting to Home page...`,
      });
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Release Flight',
        description: res.ApiStatus?.Message || 'Failed to release',
      });
    }
    setIsLoading(false);
  };

  const handleSHowConfirmPopup = (transaction) => {
    selectedTransactionRef.current = transaction;
    setShowConfirmPopup(true);
  };
  const handleShowConfirmReleasePopup = (transaction) => {
    selectedTransactionRef.current = transaction;
    setShowReleasePopup(true);
  };

  return (
    <section className="flight-hold-queues">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          variant={alert.variant}
          showIcon
          title={alert.title}
          description={alert.description}
        />
      )}
      <section className="flight-hold-queues_container py-3">
        <div className="train-search-container">
          <div className="mb-3 d-flex justify-content-end">
            <div style={{ width: '300px' }}>
              <AppTextInput
                value={searchText}
                label="search"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        {holdQueuesList && holdQueuesList.length === 0 && (
          <div className="my-bookings-page__booking">
            <span className="my-bookings-page__booking_header__trip-info">
              No booking records found.
            </span>
          </div>
        )}
        {holdQueuesList &&
          holdQueuesList.length > 0 &&
          holdQueuesList.map((booking, index) => (
            <div
              key={`${booking.Txid}_${index}`}
              className="flight-hold-queues_card my-2"
            >
              <Row className="spacing-0 p-2 ">
                <Col>
                  <FlightDetail info="Transaction Id:" value={booking.Txid} />
                </Col>
                <Col>
                  <FlightDetail
                    info="Booking Date"
                    value={`${formatDate(
                      getNewDate(booking.BookingDate.split(' ')[0]),
                      DATE_MONTH_YEAR_FORMAT,
                    )} 
                  ${booking?.BookingDate?.split(' ')[1]}`}
                  />
                </Col>
                <Col>
                  <FlightDetail
                    info="Journey Date"
                    value={`${formatDate(
                      getNewDate(booking.JDate),
                      DATE_MONTH_YEAR_FORMAT,
                    )}`}
                  />
                </Col>
                <Col>
                  <FlightDetail
                    info="Sector"
                    value={`${booking.Origin}-${booking.Destination}`}
                  />
                </Col>
                <Col>
                  <FlightDetail info="Carrier" value={booking.Carrier} />
                </Col>
              </Row>
              <Row className="spacing-0 p-2">
                <Col>
                  <FlightDetail
                    info="Pax Name"
                    value={`${booking.PassengerFirstName} ${booking.PassengerLastName}`}
                  />
                </Col>
                <Col>
                  <FlightDetail info="GDSPNR" value={booking.GdsPnr} />
                </Col>
                <Col>
                  <FlightDetail info="AirlinePNR" value={booking.AirlinePnr} />
                </Col>
                <Col>
                  <FlightDetail
                    info="Booking Status"
                    value={booking.BookingStatus}
                  />
                </Col>
                <Col>
                  <FlightDetail info="Time Limit" value={booking.TimeLimit} />
                </Col>
              </Row>
              <div className="spacing-0 row flight-hold-queues_actions">
                <div className="col-4 p-1 d-flex justify-content-center border-767px-bottom">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    isLink
                    linkText="Ticket"
                    href={getFlightTicketRoute(booking.Txid)}
                    variant="grey"
                    target="_blank"
                  />
                </div>
                <div className="col-4 p-1 d-flex justify-content-center">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    linkText="Perform Ticketing"
                    onClick={() => handleSHowConfirmPopup(booking.Txid)}
                    variant="grey"
                  />
                </div>
                <div className="col-4 p-1 d-flex justify-content-center">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    linkText="Release"
                    onClick={() => handleShowConfirmReleasePopup(booking.Txid)}
                    variant="grey"
                  />
                </div>
              </div>
            </div>
          ))}
      </section>
      {showConfirmPopup && (
        <AppModal
          modalTitle="Perform Ticketing"
          onModalClose={handleClosePerformBookingModal}
        >
          <div>
            <p className="fs-14">Are you sure you want to Perform Ticketing?</p>
            <div className="d-flex gap-2 justify-content-center">
              <AppButton
                btnText="No"
                variant="outlined"
                className="flex-1"
                onClick={handleClosePerformBookingModal}
              />
              <AppButton
                btnText="Yes"
                variant="primary"
                className="flex-1"
                onClick={handlePerformTicket}
              />
            </div>
          </div>
        </AppModal>
      )}
      {showReleasePopup && (
        <AppModal
          modalTitle="Release Ticket"
          onModalClose={handleCloseReleasePopup}
        >
          <div>
            <p className="fs-14 text-center">
              Are you sure you want to Release the Ticket?
            </p>
            <div className="d-flex gap-2 justify-content-center">
              <AppButton
                btnText="No"
                variant="outlined"
                className="flex-1"
                onClick={handleCloseReleasePopup}
              />
              <AppButton
                btnText="Yes"
                variant="primary"
                className="flex-1"
                onClick={handleReleaseTicket}
              />
            </div>
          </div>
        </AppModal>
      )}
    </section>
  );
}

export default FlightHoldQueues;
